import React, { useState } from 'react';
import { Button, Stack, Typography } from '@mui/material';

import { Modal } from 'components/Modal';

import { useUpdateApplicationStatus } from '../../api/updateApplicationStatus';
import { APPLICATION_STATUS, APPLICATION_STATUS_ACTIONS } from '../../utils/applicationStatus';

export const ApplicationStatusActions = ({ application }) => {
  const [pending, setPending] = useState(null);
  const { mutateAsync, isLoading } = useUpdateApplicationStatus();

  const currentStatus = application?.status ?? 'new';
  const actions = APPLICATION_STATUS_ACTIONS.filter(({ status }) => status !== currentStatus);

  const handleClose = () => setPending(null);

  const handleConfirm = () =>
    mutateAsync({ applicationID: application.application_id, status: pending.status })
      .then(handleClose)
      .catch(() => {});

  return (
    <>
      <Stack direction="row" gap={1}>
        {actions.map((action) => (
          <Button
            key={action.status}
            variant={action.status === 'new' ? 'text' : 'outlined'}
            size="small"
            onClick={() => setPending(action)}
          >
            {action.label}
          </Button>
        ))}
      </Stack>

      <Modal open={!!pending} handleClose={handleClose} title="Update application status">
        <Typography variant="body1" fontWeight={500}>
          Are you sure you want to set this application to{' '}
          <span style={{ fontWeight: 'bold' }}>{APPLICATION_STATUS[pending?.status]?.label}</span>?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {pending?.notifies
            ? 'The supplier will be notified in the app and by email.'
            : 'The supplier will not be notified.'}
        </Typography>

        <Stack direction="row" justifyContent="center" gap={1}>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleConfirm} disabled={isLoading}>
            Confirm
          </Button>
        </Stack>
      </Modal>
    </>
  );
};
